import React, { Component } from "react";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";

class DateRangeCalendar extends Component {
  state = {
    date: ["", ""]
  };

  onChange = date => {
    this.setState({ date }, function() {
      if (this.state.date) {
        let dates = [...this.state.date];
        this.props.onSelectedDates(dates);
      } else {
        this.props.onSelectedDates(date);
      }
    });
  };

  resetDates = () => {
    console.log("reset dates...");
    let date = { ...this.state.date };
    date = ["", ""];
    this.setState({ date });
  };

  render() {
    return (
      <div>
        <DateRangePicker
          onChange={this.onChange}
          value={this.state.date}
          calendarType="US"
          maxDate={this.props.maxDate}
          monthPlaceholder="mm"
          dayPlaceholder="dd"
          yearPlaceholder="yyyy"
          format="MM-dd-yyyy"
        />
      </div>
    );
  }
}
export default DateRangeCalendar;
